module.exports = __webpack_public_path__ + "static/media/phone-call-footer.a0bc6089.svg";